import React from "react";
import "./listen.css";

const tracks = [
  // mp3 files in: public/audio/
  { id: 1, title: "6174 (not feat. Nelly) ", file: "/audio/6174.mp3" },
  { id: 2, title: "Drunken Forest", file: "/audio/Drunken Forest - 8.mp3" },
  { id: 3, title: "Little Middle", file: "/audio/Little Middle.mp3" },
  { id: 4, title: "Fence Sitter", file: "/audio/Fence Sitter 29.mp3" },
  { id: 5, title: "Japanese Cowboy", file: "/audio/Japanese Cowboy.mp3" },
  { id: 6, title: "Cardinals 1 - Bluejays 0", file: "/audio/Cardinals 1 - Bluejays 0 14.mp3" },
  { id: 7, title: "Stereo Talk", file: "/audio/Stereo Talk 7.mp3" },
];

export default function Listen() {
  return (
    <main className="page listen-page">
      <section className="panel listen-panel">
        <h1>Listen</h1>
        <h2 className="audio-muted">Charcuterie</h2>
        <div className="audio-list">
          {tracks.map((t) => (
            <div className="audio-track" key={t.id}>
              <div className="audio-track-meta">
                <div className="audio-track-title">{t.title}</div>
                <a className="audio-download" href={t.file} download>
                  Download
                </a>
              </div>

              <audio className="audio-audio" controls preload="none">
                <source src={t.file} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}